import { type FC } from 'react';
import { type ToastOptions } from 'react-toastify';

import { errorToast } from '@/helpers';
import { _isNotBlank } from '@/littledash';
import { parseApiErrorResponse } from '@/utils/apiErrorResponse';

import styles from './RequestErrorToast.module.scss';

const DEFAULT_AUTO_CLOSE_MS = 15_000;

interface RequestErrorToastContentProps {
  title: string;
  message?: string;
  testId?: string;
}

export const RequestErrorToastContent: FC<RequestErrorToastContentProps> = ({
  title,
  message,
  testId = 'request-error-toast',
}) => (
  <div data-testid={testId}>
    <p className={`fw6 ${styles.title}`} data-testid={`${testId}__title`}>
      {title}
    </p>
    {_isNotBlank(message) && (
      <p className={`f6 lh-copy ${styles.message}`} data-testid={`${testId}__message`}>
        {message}
      </p>
    )}
  </div>
);

export interface RequestErrorToastParams {
  title: string;
  error: unknown;
  options?: ToastOptions;
  testId?: string;
}

export const requestErrorToast = ({ title, error, options, testId }: RequestErrorToastParams): void => {
  const { summary } = parseApiErrorResponse(error);

  errorToast(<RequestErrorToastContent title={title} message={summary} testId={testId} />, {
    autoClose: DEFAULT_AUTO_CLOSE_MS,
    closeOnClick: false,
    className: styles.toast,
    ...(options ?? {}),
  });
};
